<div style="width: 100%;">
    <div class="controls">
        <button mat-stroked-button color="primary" (click)="getLogins()" [disabled]="submiting">
            <mat-icon>refresh</mat-icon>
            Carregar dados
        </button>
    </div>

    <ng-container *ngIf="submiting">
        <div class="empty-content" style="width: 100%">
            <mat-progress-spinner mode="indeterminate" diameter="30"></mat-progress-spinner>
        </div>
    </ng-container>

    <ng-container *ngIf="submiting == false">

        <ng-container *ngIf="pieChartData == null">
            <div class="empty-content" style="width: 100%">
                Resultado do filtro aparecerá aqui
            </div>
        </ng-container>

        <ng-container *ngIf="pieChartData?.length == 0">
            <div class="empty-content" style="width: 100%">
                Nenhum resultado encontrado!
            </div>
        </ng-container>

        <ng-container *ngIf="pieChartData?.length > 0">

            <div style="
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                ">
                <div style="flex: 1">
                    <table class="table" mat-table [dataSource]="datasource">
                        <ng-container *ngFor="let attr of displayedColumns">
                            <ng-container [matColumnDef]="attr">
                                <th mat-header-cell *matHeaderCellDef>
                                    <span class="th-wrapper">
                                        {{ columnsDisplayName[attr] }}
                                    </span>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element[attr] }}
                                </td>
                            </ng-container>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns" style="cursor: pointer"></tr>
                    </table>
                </div>
                <div #pieChartContainer style="flex: 1">
                    <ngx-charts-pie-chart [view]="[pieChartWidth, pieChartWidth]" [results]="pieChartData"
                        [gradient]="false" [legend]="true" legendTitle="Qtd de logins" [labels]="false"
                        [doughnut]="false">
                    </ngx-charts-pie-chart>
                </div>
            </div>

        </ng-container>

    </ng-container>
</div>